export default __webpack_public_path__ + "static/media/image_2.17fd71cf.png";